import i18next from "i18next"
import dateService from "services/date"
import saveAs from "file-saver"
import XlsxPopulate from "xlsx-populate"

import { domainPathname } from "utils/functions"

const STARTING_LINE = 5

const getWorkbook = async () => {
    return new Promise(function (resolve, reject) {
        const req = new XMLHttpRequest()
        const url = `${domainPathname}/error-bikes-template-${i18next.language.toUpperCase()}.xlsx`
        req.open("GET", url, true)
        req.responseType = "arraybuffer"

        req.onreadystatechange = function () {
            // https://developer.mozilla.org/fr/docs/Web/API/XMLHttpRequest/readyState
            // 4 === DONE
            if (req.readyState === 4){
                if (req.status === 200) {
                    resolve(XlsxPopulate.fromDataAsync(req.response))
                } else {
                    reject("Received a " + req.status + " HTTP code.")
                }
            }
        }
        req.send()
    })
}

export const exportOutputErrorBikeCollectionFile = async (bikeCollectionErrors, bikeCollectionFromInputFile) => {
    const createOutputErrorBikeCollectionFile = async (type) => {
        const workbook = await getWorkbook()
        const workbookFirstSheet = workbook.sheet(0)
        let bikeIndex = STARTING_LINE

        for (const bikeError of bikeCollectionErrors) {
            const bike = bikeCollectionFromInputFile.find(bike => bike.id === bikeError.id)
            const errorMessage = bikeError?.import_result?.message // Error message on the last column

            const vae = bike?.bike_description?.is_electric && bike.bike_description.is_electric === true ? i18next.t("global.yes") : i18next.t("global.no")
            const bikeStyles = { "fontColor": "000000", "italic": false, "horizontalAlignment": "center" }

            workbookFirstSheet.cell(`A${bikeIndex}`).value(bike?.bike_id ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`B${bikeIndex}`).value(bike.bike_description?.gear_type ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`C${bikeIndex}`).value(bike.bike_description?.brand ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`D${bikeIndex}`).value(bike.bike_description?.model ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`E${bikeIndex}`).value(bike.bike_description?.color ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`F${bikeIndex}`).value(vae).style(bikeStyles)

            workbookFirstSheet.cell(`G${bikeIndex}`).value(bike.bike_description?.frame_serial_number ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`H${bikeIndex}`).value(bike.bike_description?.engine_serial_number ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`I${bikeIndex}`).value(bike.bike_description?.battery_serial_number ?? "").style(bikeStyles)

            workbookFirstSheet.cell(`J${bikeIndex}`).value(bike.bike_owner?.private_owner?.last_name ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`K${bikeIndex}`).value(bike.bike_owner?.private_owner?.first_name ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`L${bikeIndex}`).value(bike.bike_owner?.private_owner?.phone ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`M${bikeIndex}`).value(bike.bike_owner?.private_owner?.mail ?? "").style(bikeStyles)

            workbookFirstSheet.cell(`N${bikeIndex}`).value(bike.bike_owner?.company_owner?.social_reason ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`O${bikeIndex}`).value(bike.bike_owner?.company_owner?.phone ?? "").style(bikeStyles)
            workbookFirstSheet.cell(`P${bikeIndex}`).value(bike.bike_owner?.company_owner?.mail ?? "").style(bikeStyles)

            workbookFirstSheet.cell(`Q${bikeIndex}`).value(bike.bike_owner?.owner_by_id?.consumer_id ?? "").style(bikeStyles)

            workbookFirstSheet.cell(`R${bikeIndex}`).value(errorMessage).style({ "fontColor": "000000", "italic": false, "wrapText": true, "underline": false })
            workbookFirstSheet.column("R").width(100)
            bikeIndex++
        }
        return workbook.outputAsync({ type })
    }

    await createOutputErrorBikeCollectionFile()
        .then((blob) => {
            const timestamp = dateService.getCurrentDate("dd-MM-y-HH'h'mm")
            const fileName = i18next.t("output_filename", { ns: "bikeCollectionImport", timestamp })
            saveAs(new Blob([blob]), fileName)
        })
        .catch((err) => {
            console.error(err.message || err)
            throw err
        })
}